import { render, staticRenderFns } from "./PartComponent.vue?vue&type=template&id=47e13dcb&"
import script from "./PartComponent.vue?vue&type=script&lang=js&"
export * from "./PartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports